import { useEffect, useState } from 'react';
import { invoicesApi } from '@/services/api';
import { Download, FileText, Loader2 } from 'lucide-react';

/**
 * PDF-Vorschau als Blob-URL im iframe — ein direkter /api/…-URL im
 * iframe geht nicht (kein Bearer im iframe-Request) und das globale
 * X-Frame-Options: DENY würde greifen. Ohne PDF-Viewer zeigt der
 * iframe nichts, deshalb steht der Download-Button immer daneben.
 */
export function InvoicePdfPreview({ invoiceId, fileName }: { invoiceId: number; fileName?: string | null }) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    setIsLoading(true);
    setError(false);
    setBlobUrl(null);
    invoicesApi
      .getFileBlob(invoiceId)
      .then((response) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setBlobUrl(objectUrl);
        setIsLoading(false);
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setIsLoading(false);
        }
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [invoiceId]);

  const handleDownload = () => {
    if (!blobUrl) return;
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName || 'rechnung.pdf';
    a.click();
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8 bg-gray-50 rounded-lg">
        <Loader2 className="h-5 w-5 animate-spin text-primary-600" />
      </div>
    );
  }

  if (error || !blobUrl) {
    return (
      <div className="card p-4 text-center text-sm text-gray-500">
        <FileText className="mx-auto mb-2 h-6 w-6 text-gray-400" />
        PDF-Vorschau nicht verfügbar
      </div>
    );
  }

  return (
    <div>
      <iframe src={blobUrl} title="Rechnung" className="h-[480px] w-full rounded-lg border border-gray-200 bg-gray-50" />
      <div className="mt-2">
        <button onClick={handleDownload} className="btn btn-secondary inline-flex items-center gap-2 text-sm">
          <Download className="h-4 w-4" />
          Herunterladen{fileName ? ` (${fileName})` : ''}
        </button>
      </div>
    </div>
  );
}